import { useState } from "react";
import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

const tabs = [
  { id: "hot", label: "最热连载", icon: "ri-fire-line" },
  { id: "new", label: "最新更新", icon: "ri-time-line" },
  { id: "rising", label: "高分佳作", icon: "ri-medal-line" },
];

export default function PopularGrid() {
  const [active, setActive] = useState("hot");

  const sorted = [...comics].sort((a, b) => {
    if (active === "hot") return b.views - a.views;
    if (active === "new") return b.updatedAt.localeCompare(a.updatedAt);
    return b.rating - a.rating;
  });

  const list = sorted.slice(0, 8);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              热门漫画推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              根据人气、更新与评分精选，实时为你推荐值得一追的韩漫
            </p>
          </div>
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200 self-start">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActive(tab.id)}
                className={`inline-flex items-center gap-1.5 px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active === tab.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="flex justify-center mt-9">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-11 px-7 rounded-md border border-primary-300 text-primary-700 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            浏览全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}